import { Directive, forwardRef, Provider} from '@angular/core';
import { CheckboxRequiredValidator, NG_VALIDATORS } from '@angular/forms';

export const SABIS_CHECKBOX_REQUIRED_VALIDATOR: Provider = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => SabisNgxCheckboxRequiredValidator),
  multi: true
};

/**
 * Validator for sabis-checkbox's required attribute in template-driven checkbox.
 */
@Directive({
  selector: `sabis-ngx-checkbox[required][formControlName],
             sabis-ngx-checkbox[required][formControl], sabis-ngx-checkbox[required][ngModel]`,
  providers: [SABIS_CHECKBOX_REQUIRED_VALIDATOR],
  host: { '[attr.required]': 'required ? "" : null' }
})
export class SabisNgxCheckboxRequiredValidator extends CheckboxRequiredValidator { }
